<template>
  <label :for="id" class="label"
    ><slot></slot><sup class="text-red-600" v-if="required">*</sup></label
  >

  <span class="flex ">
  <select
    :name="id"
    :id="id"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    class="input flex-1"
    :class="{ 'ring ring-red-500 ring-opacity-50': error }"
    :disabled="disabled"
  >
    <option value="" v-if="!hide_null_label">{{ nullLabel }}</option>
    <option
      :value="itemValue ? item[itemValue] : item"
      v-for="item in items"
      :key="item.id"
      v-text="itemLabel ? item[itemLabel] : item"
    ></option>
  </select>
  <slot name="suffix"></slot>
  </span>

  <span class="text-xs text-red-600" role="alert" v-if="error">
    {{ error }}
  </span>
</template>

<script>
export default {
  props: {
    id: String,
    error: String,
    modelValue: [String, Number],
    items: Array,
    itemValue: String,
    itemLabel: String,
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hide_null_label: {
      type: Boolean,
      default: false,
    },
    nullLabel: {
      type: String,
      default: "- Select -",
    },
  },
  emits: ["update:modelValue"],
};
</script>
